import ActionTypes from '../actionTypes/actionTypes';

export const manageTheme = theme => ({
    type: ActionTypes.MANAGE_THEME,
    theme
});